<template>
  <WdsModal :show="show" :title="title" @cancel="$emit('cancel')">
    <WdsStack justify-center align-center direction-column gap-md class="content">
      <div class="icon-outer">
        <div class="icon-inner">
          <WdsIcon name="trash-can" color="#D12223" size="24"></WdsIcon>
        </div>
      </div>
      <WdsText large>
        {{ $t('Are you sure you want to delete this workflow?') }}
      </WdsText>
      <WdsText secondary>
        <BaseHtml
          :html="
            $t('This action <strong>cannot be undone</strong> and it will permanently delete it')
          "
        />
      </WdsText>
      <WdsStack justify-space-between align-center class="tw-w-full">
        <WdsButton :disabled="deletingWorkflowRunning" @click="$emit('cancel')">
          {{ $t('Cancel') }}
        </WdsButton>
        <WdsButton
          :disabled="deletingWorkflowRunning"
          error
          data-test="delete-workflow-button"
          @click.prevent="$emit('delete')"
        >
          {{ $t('Delete') }}
          <WdsSpinner v-if="deletingWorkflowRunning" indeterminate class="tw-m-0.5" />
        </WdsButton>
      </WdsStack>
    </WdsStack>
  </WdsModal>
</template>

<script setup>
import {
  WdsText,
  WdsStack,
  WdsIcon,
  WdsModal,
  WdsButton,
  WdsSpinner,
} from '@worksome/wds-components'
import { computed } from 'vue'
import BaseHtml from '@/components/BaseHtml.vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

defineEmits(['cancel', 'delete'])

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  deletingWorkflowRunning: {
    type: Boolean,
    default: false,
  },
  workflowTitle: {
    type: String,
    required: true,
  },
})

const title = computed(() =>
  $t('Delete ":workflow-title"', { 'workflow-title': props.workflowTitle }),
)
</script>

<style lang="scss" scoped>
.content {
  :deep(strong) {
    color: black;
  }

  .icon-outer {
    border-radius: 50%;
    background-color: #fdf2f2;
    padding: 6px;
    .icon-inner {
      padding: 5px;
      border-radius: 50%;
      background-color: #f9e0e0;
    }
  }
}
</style>
